import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67ac6f43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p class=\"description\" data-v-67ac6f43><span class=\"c-gr\" data-v-67ac6f43>Welcome!</span></p><h1 class=\"c-gy2\" data-v-67ac6f43>C&amp;C Ventures LLC</h1><p class=\"description\" data-v-67ac6f43> Hello, we are <span class=\"c-gr\" data-v-67ac6f43>Chris and Connor</span>, cofounders of C&amp;C Ventures LLC. Here we <span class=\"c-gr\" data-v-67ac6f43>strive for excellence</span> in software products. During the day, we are both Software Engineers with over <span class=\"c-gr\" data-v-67ac6f43>12+ years of experience</span> building mobile apps, websites, APIs, and even some games. At night, we are <span class=\"c-gr\" data-v-67ac6f43>entrepreneurs</span> who are passionate about creating products that <span class=\"c-gr\" data-v-67ac6f43>solve real-world problems</span> and <span class=\"c-gr\" data-v-67ac6f43>improve people&#39;s lives</span>. </p>", 3)
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow" }, "→", -1))

import F1 from '@/components/F1.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'IntroComponent',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      class: "rounded-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('scrollToSkills')))
    }, [
      _createTextVNode(" Together, we have built some pretty cool products "),
      _hoisted_5
    ])
  ]))
}
}

})